/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const REASONS = {
    INACTIVE_CLAN: 'inactive_clan',
    DEMANDING_CLAN: 'demanding_clan',
    TOO_SKILLED_CLAN: 'too_skilled_clan',
    TOO_UNSKILLED_CLAN: 'too_unskilled_clan',
    QUARRELED_WITH_THE_PLAYERS: 'quarreled_with_the_players',
    DONT_PLAN_TO_PLAY_IN_CLAN: 'dont_plan_to_play_in_clan',
    OTHER: 'other',
}

export const REASONS_TEXT = {
    INACTIVE_CLAN: (
        <FormattedMessage id="clan_leaving.reasons.inactive_clan" defaultMessage="Клан недостаточно активный" />
    ),
    DEMANDING_CLAN: (
        <FormattedMessage
            id="clan_leaving.reasons.demanding_clan"
            defaultMessage="Не могу уделять достаточно времени этому клану"
        />
    ),
    TOO_SKILLED_CLAN: (
        <FormattedMessage
            id="clan_leaving.reasons.too_skilled_clan"
            defaultMessage="В клане слишком высокий уровень мастерства"
        />
    ),
    TOO_UNSKILLED_CLAN: (
        <FormattedMessage
            id="clan_leaving.reasons.too_unskilled_clan"
            defaultMessage="В клане слишком низкий уровень мастерства"
        />
    ),
    QUARRELED_WITH_THE_PLAYERS: (
        <FormattedMessage
            id="clan_leaving.reasons.quarreled_with_the_players"
            defaultMessage="Не сложились отношения в клане"
        />
    ),
    DONT_PLAN_TO_PLAY_IN_CLAN: (
        <FormattedMessage
            id="clan_leaving.reasons.dont_plan_to_play_in_clan"
            defaultMessage="Не планирую больше состоять в каком-либо клане"
        />
    ),
    OTHER: <FormattedMessage id="clan_leaving.reasons.other" defaultMessage="Нет подходящего ответа" />,
}

export const REASON_QUESTION = (
    <FormattedMessage id="clan_leaving.reasons.question" defaultMessage="Почему вы решили покинуть клан?" />
)



// WEBPACK FOOTER //
// ./containers/ClanLeaving/components/Reasons/constants.jsx